export const formatedDate = (date1) => {
  if (date1 === null || date1 === "" || date1 === undefined) {
    return null;
  }
  const date = new Date(date1);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1.
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const timeAgo = (date1) => {
  if(date1 === null || date1 === "" || date1 === undefined){
    return null;
  }
  const now = new Date();
  const past = new Date(date1);
  const diffMs = now - past;

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMinutes < 60) {
    return `${diffMinutes}m ago`;
  } else if (diffHours < 24) {
    return `${diffHours}h ago`;
  } else if (diffDays === 1) {
    return `1 day ago`;
  } else {
    return `${diffDays} days ago`;
  }
}

export const toLocalDateTime = (isoString) => {
  const date = new Date(isoString); 
  const localDate = date.toLocaleDateString();
  const localTime = date.toLocaleTimeString();
  return `${localDate} ${localTime}`;
}

export const convertToLocalDateTime = (utcTimestamp) => {
    const date = new Date(utcTimestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return {
        date: `${day}-${month}-${year}`,
        time: `${hours}:${minutes}` 
    };
}

